module.exports = __webpack_public_path__ + "img/vertical-right.339a3833.svg";